<template>
  <div class="customPos" v-if="dialogVisible">
    <div class="customPosCont">
      <div class="header">
        <div class="title">自定义海报风格</div>
        <div class="headerbtn" @click="closeCus">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="body">
        <div class="content">
          <div class="left">
            <div class="customSetUp">
              <el-form :label-position="labelPosition" label-width="90px">
                <el-form-item label="风格名称" class="special">
                  <el-input v-model="styleName" maxlength="20"></el-input>
                </el-form-item>
                <p class="tipUpload">为保证最佳效果，建议尺寸：1200PX * 1800PX</p>
                <el-form-item label="上传背景底图" class="uploadBg">
                  <input type="file" id="uploadCusBg" value="imgFile" ref="cusBgFile" accept="image/png, image/jpeg, image/jpg" @change="uploadCusBg($event)" style="display: none;" />
                  <label class="uploadCusButton" for="uploadCusBg">上传+</label>
                </el-form-item>
                <el-form-item label="显示二维码">
                  <el-select v-model="isShowCode" @change="changeCode">
                    <el-option v-for="item in codeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="显示作品名称" class="special">
                  <el-select v-model="isShowName" @change="changeName">
                    <el-option v-for="item in nameOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="" class="special">
                  <el-input v-model="posterName" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="显示提示文字" class="special">
                  <el-select v-model="isShowText" @change="changeText">
                    <el-option v-for="item in textOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="" class="special">
                  <el-input v-model="posterPromptText" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="分享封面">
                  <el-select v-model="isShowCover" @change="changeCover">
                    <el-option
                      v-for="(item, index) in coverCurOptions"
                      :key="item.value || index"
                      :label="item.label || item.title || item.name"
                      :value="item.value || item.coverUrl"
                      @click.native="handleSelect(index)"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="button">
              <button @click="cancelDia" class="cancelDia">取消</button>
              <button @click="saveCus" class="saveCus">确定</button>
            </div>
          </div>
          <div class="right">
            <PosterCont ref="posterCont" :size="size" :qrObj="qrObj" @getCoverOption="getCoverOption" @getTitle="getTitle" @getSelData="getSelData"></PosterCont>
          </div>
        </div>
      </div>
    </div>
    <posterCurShear ref="posterCurShear" @getBgUrl="getBgUrl"></posterCurShear>
  </div>
</template>

<script>
import PosterCont from './posterCont'
import api from '@api/getBook'
import posterCurShear from './posterCusShear'
import { base64ToFile } from '@/utils'
export default {
  name: 'customPos',
  data() {
    return {
      dialogVisible: false,
      file: null,
      // qrObj: {
      //   value: window.location.href.replace('book', 'content')
      // },
      CurPage: true,
      labelPosition: 'right',
      styleName: '',
      isShowCode: 1,
      isShowName: 1,
      isShowText: 1,
      isShowCover: '',
      posterName: '',
      // posterName: this.$refs.posterCont.title,
      // posterPromptText: this.$refs.posterCont.tipText,
      posterPromptText: '微信识别二维码',
      codeOptions: [
        {
          label: '否',
          value: 0
        },
        {
          label: '是',
          value: 1
        }
      ],
      nameOptions: [
        {
          label: '否',
          value: 0
        },
        {
          label: '是',
          value: 1
        }
      ],
      textOptions: [
        {
          label: '否',
          value: 0
        },
        {
          label: '是',
          value: 1
        }
      ],
      coverOptions: [
        {
          label: '显示首页',
          value: 1
        },
        {
          label: '显示当前浏览页',
          value: 2
        }
      ],
      coverCurOptions: [
        {
          label: '显示首页',
          value: 1
        },
        {
          label: '显示当前浏览页',
          value: 2
        }
      ],
      cropImgUrl: '',
      size: 54,
      imgUrl: '',
      customWhere: '',
      coverIndex: null,
      bgUrl: ''
    }
  },
  computed: {
    isMember() {
      return this.$store.state.common.vipInfo.isMember
    }
  },
  watch: {
    bgUrl(val) {
      if (this.$refs.posterCont) {
        if (val == 'poster.png') {
          this.$refs.posterCont.nowbgimg = require('@imgs/poster.png')
        } else {
          this.$refs.posterCont.nowbgimg = val
        }
      }
    },
    posterName(val) {
      if (this.$refs.posterCont) {
        this.$refs.posterCont.title = val
      }
    },
    posterPromptText(val) {
      if (this.$refs.posterCont) {
        this.$refs.posterCont.tipText = val
      }
    }
  },
  methods: {
    uploadCusBg(e) {
      var _this = this
      //上传图片
      this.file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(_this.file)
      imgFile.onload = (res) => {
        _this.$refs.posterCurShear.cropImgUrl = res.target.result
        _this.$refs.cusBgFile.value = ''
        _this.$refs.posterCurShear.dialogVisible = true
        _this.$nextTick(() => {
          _this.$refs.posterCurShear.init()
        })
      }
    },
    saveCus() {
      if (this.styleName == '') {
        this.$message({
          message: '需要输入风格名称',
          type: 'error'
        })
        return
      }
      let showCover = null
      if (this.$refs.posterCont.customWhere == 'book' || this.$refs.posterCont.customWhere == 'default') {
        showCover = this.isShowCover
      } else {
        showCover = 1
      }
      let custom = {
        posterQrCodeShow: this.isShowCode,
        posterNameShow: this.isShowName,
        posterName: this.posterName,
        posterTextShow: this.isShowText,
        posterPromptText: this.posterPromptText,
        posterCover: [showCover, this.$refs.posterCont.noTimerUrl]
      }
      if (this.$refs.posterCont.customWhere == 'book' || this.$refs.posterCont.customWhere == 'default') {
        this.$store.commit('config/UPDATE_POSTERBOOK', custom)
      } else if (this.$refs.posterCont.customWhere == 'album') {
        this.$store.commit('config/UPDATE_POSTERALBUM', custom)
      } else if (this.$refs.posterCont.customWhere == 'lib') {
        this.$store.commit('config/UPDATE_POSTERLIB', custom)
      }
      this.$emit('getCustomTit', this.styleName)
      if (this.bgUrl) {
        if (this.bgUrl.includes('data:image')) {
          let file = base64ToFile(this.bgUrl)
          let params = new FormData()
          params.append('posterImg', file)
          api.uploadPosterPic(params).then((res) => {
            if (res && res.data && res.data.code === 0) {
              this.dialogVisible = false
              this.imgUrl = res.data.data
              this.$store.commit('config/UPDATE_POSTERBG', '')
              this.$emit('getCusImg', this.imgUrl)
            }
          })
        } else {
          this.$emit('getCusImg', this.bgUrl)
          this.dialogVisible = false
        }
      } else {
        this.dialogVisible = false
      }
    },
    cancelDia() {
      this.dialogVisible = false
      this.$store.commit('config/UPDATE_POSTERBG', '')
    },
    closeCus() {
      this.dialogVisible = false
    },
    changeCode() {
      if (this.isShowCode) {
        this.$refs.posterCont.showCode = true
      } else {
        this.$refs.posterCont.showCode = false
      }
    },
    changeName() {
      if (this.isShowName) {
        this.$refs.posterCont.showTit = true
      } else {
        this.$refs.posterCont.showTit = false
      }
    },
    changeText() {
      if (this.isShowText) {
        this.$refs.posterCont.showTip = true
      } else {
        this.$refs.posterCont.showTip = false
      }
    },
    changeCover(val) {
      if (val == 2 || val == 1) {
        return false
      }
      this.$refs.posterCont.nowUrl = val
      this.$refs.posterCont.noTimerUrl = val
    },
    handleSelect(index) {
      this.coverIndex = index
    },
    getCoverOption(val) {
      if (val == 'book') {
        this.coverCurOptions = this.coverOptions
      } else {
        this.coverCurOptions = val
      }
      // this.isShowCover = this.coverCurOptions[0] ? this.coverCurOptions[0].coverUrl || this.coverCurOptions[0].value : []
    },
    getTitle(val) {
      // this.coverCurOptions = val
      this.posterName = val
    },
    getSelData(val) {
      this.isShowName = val[0] == 1 ? 1 : 0
      this.isShowText = val[1] == 1 ? 1 : 0
      this.isShowCode = val[2] == 1 ? 1 : 0
      this.posterPromptText = val[3]
      this.styleName = val[4] || '默认风格'
      this.bgUrl = val[5]
    },
    getBgUrl(val) {
      this.bgUrl = val
    }
  },
  components: {
    PosterCont,
    posterCurShear
  },
  props: {
    qrObj: Object
  }
}
</script>

<style lang="scss" scoped>
.customPos {
  // width: 633px;
  // height: 480px;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .customPosCont {
    width: 730px;
    height: 520px;
    background: #fff;
    .header {
      background: #f4f4f4;
      color: #000000;
      padding: 0;
      height: 42px;
      position: relative;
      .title {
        font-size: 14px;
        line-height: 42px;
        text-align: center;
      }
      .headerbtn {
        position: absolute;
        right: 13px;
        top: 13px;
        width: 13px;
        height: 13px;
        cursor: pointer;
        i {
          width: 100%;
          color: #979797;
          line-height: 13px;
          vertical-align: top;
        }
      }
    }
    .body {
      padding-top: 20px;
      .content {
        display: flex;
        justify-content: space-evenly;
        .left {
          height: 420px;
          width: 340px;
          position: relative;
          .customSetUp {
            width: 100%;
            border: 1px solid #cecece;
            padding: 20px 0 10px 0;
            /deep/ .el-input__inner {
              width: 200px !important;
              height: 28px !important;
            }
            .el-input {
              width: 200px;
              height: 28px;
            }
            .el-form {
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
            }
            /deep/ .el-input__inner {
              width: 150px;
              // height: 20px !important;
              height: 20px;
            }
            /deep/ .el-form-item__label {
              font-size: 14px;
              color: #515151;
              height: 28px;
              line-height: 28px;
              width: 100px !important;
            }
            /deep/ .el-form-item__content {
              height: 20px;
              line-height: 20px;
              margin-left: 100px !important;
            }
            /deep/ .el-input__icon {
              line-height: 20px;
            }
            .el-form-item {
              margin-bottom: 10px;
              height: 28px;
            }
            .uploadBg {
              height: 30px;
              /deep/ .el-form-item__content {
                height: 30px;
                line-height: 30px;
              }
              /deep/ .el-form-item__label {
                height: 30px;
                line-height: 30px;
              }
            }
            .uploadCusButton {
              width: 200px;
              height: 30px;
              background: #df5813;
              color: #fff;
              font-size: 14px;
              display: inline-block;
              text-align: center;
              cursor: pointer;
              border-radius: 4px;
            }
            .tipUpload {
              margin: 0;
              font-size: 14px;
              text-align: center;
              color: #df5813;
              margin-bottom: 10px;
              // width: 240px;
              width: 100%;
            }
            // .special {
            //   margin-bottom: 10px;
            // }
          }
          .button {
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            margin-top: 20px;
            button {
              width: 120px;
              height: 40px;
              background: #a9a9a9;
              cursor: pointer;
              color: #fff;
              border: none;
              font-size: 14px;
            }
            .saveCus {
              background: #df5813;
            }
          }
          .fileName {
            margin: 0;
            margin-top: -13px;
            // margin-bottom: 5px;
            // padding: 0 26px;
            text-align: right;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            width: 240px;
          }
        }
        .right {
          width: 300px;
          height: 430px;
          border: 1px solid #f4f4f4;
          -webkit-box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
          -moz-box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
          -o-box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
          -ms-box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
          box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
          /deep/ .posterBg {
            height: 100%;
            display: flex;
            justify-content: center;
            .posterInner {
              width: 240px;
              height: 420px;
              position: relative;
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              .title {
                position: absolute;
                // left: 0;
                top: 30px;
                line-height: 18px;
                width: 212px;
                text-align: center;
                font-weight: bold;
              }
              .bookImg {
                width: 100%;
                position: absolute;
                bottom: 73px;
                display: flex;
                justify-content: center;
                .cover {
                  max-width: 200px;
                  max-height: 280px;
                  position: relative;
                  z-index: 3;
                }
                .bookcase {
                  position: absolute;
                  bottom: -18px;
                  left: 50%;
                  transform: translateX(-50%);
                  z-index: 2;
                  width: 100%;
                }
              }
              .codeFooter {
                position: absolute;
                bottom: 0;
                width: 100%;
                font-size: 14px;
                height: 54px;
                margin-top: 10px;
                span {
                  display: inline-block;
                  height: 54px;
                  line-height: 54px;
                }
                // p {
                //   text-align: center;
                // }
              }
            }
          }
        }
      }
    }
  }
}
</style>
